export const DIGITS_INPUT_FILTER_REPLACE_REGEX = /\D/g

/** 驗證數字字串 */
const digitsOnlyRegex = /^\d+$/
export const isDigitsOnly = (value: string) => digitsOnlyRegex.test(value)

/** 過濾輸入，只保留數字 */
export const filterDigitsOnly = (value: string) =>
  value.replace(DIGITS_INPUT_FILTER_REPLACE_REGEX, '')
